import React, { useEffect, useState , useMemo , useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../StyleSheet/MainComponent/GeoLocation/State.scss";
import {
  setGeoLoactionStateAction,
  setStateDeleteActions,
  getSideBarfilesActions,
  setTablePositionPersist
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import StateCreatePOPUP from "./StateCreate";
import Delete from "../../AppComponent/Popup/Delete";
import StateCreateForm from "./StateCreate";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";

import { NavLink } from "react-router-dom";
const State = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
 const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.Overall_stateDatas?.page == undefined
      ? 1
      : TablePositionPersist.Overall_stateDatas.page
  );
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
const [search,setsearch] = useState(
    TablePositionPersist?.Overall_stateDatas?.search == undefined ||
    TablePositionPersist?.Overall_stateDatas?.search == ""
      ? ''
      : TablePositionPersist?.Overall_stateDatas?.search
  ); 

  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);
  const [newpages, setNewpage] = useState(1);
  const [StateCreatePOPUP, setStateCreatepopUP] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [CreatePopup, setCreatePopup] = useState(false);
  const [EditId, setEditId] = useState();
  useEffect(() => {
    const payloads = {
      search: search,
      page_size: dtpagesize,
      page: dtpageindex,
    };
    //  if (
    //   state.GeoState.State.length == 0 ||
    //   TablePositionPersist?.Overall_stateDatas?.page != dtpageindex ||
    //   TablePositionPersist?.Overall_stateDatas?.search != search ||
    //   TablePositionPersist?.Overall_stateDatas?.updated
    //   // apiTriggerCount == true
    // ) {  

    dispatch(setGeoLoactionStateAction(payloads));
      dispatch(
          setTablePositionPersist({ data: payloads, pageName: "Overall_stateDatas" })
        );

      // }
     currentRef.current.scrollTop=sessionStorage.getItem("StateListPageTableScrollPosition")
        setdatas(state.GeoState.State);
  }, [dtpageindex , search]);

  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };


  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
setsearch(e)
      }, 500),
    []
  );


  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1)
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const HandelDelete = () => {
      setdtPageindex(1)
     const payloads_tocall = {
      search: "",
      page_size: 20,
      page: 1,
      };
      dispatch(setTablePositionPersist({data:payloads_tocall,pageName:"cliOverall_stateDatasentPage"}))
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPage: currentPage,
      };
      dispatch(setStateDeleteActions(payload, setDeletePOPUP(false)));
    }
  };
  const truncate = (value, length = 10) => {
  if (!value) return "";
  return value.length > length ? value.substring(0, length) + "..." : value;
};

  const columns = [
{
  Header: "State",
  accessor: "state_name",
  Cell: ({ value }) => truncate(value, 12), // adjust length as needed
}
,
    {
      Header: "Description",
      accessor: "",
  Cell: ({ row }) => truncate(row?.original?.description ?? "", 20),

    },
    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  setEditId(row.row.original.id);
                  setCreatePopup(true);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>

              </button>
{state.ClientBranchIDs.SUBROLE == 3 && (

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">

                <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>              </button>
)}
            </div>
          </>
        );
      },
    },
  ];
const currentRef = useRef();
const scrollPosition = (e) => {
  const val = currentRef.current.scrollTop;
  sessionStorage.setItem("StateListPageTableScrollPosition", val);
};

  return (
    <>
      <div 
       onScroll={scrollPosition}
      ref={currentRef}      
      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>State</h3>

          </div>
          <div className="Add-User col-sm-5">
{state.ClientBranchIDs.SUBROLE == 3 && (

            <button
              //  onClick={(e) => setRoleCreatePopup(true)}
              onClick={(e) => {
                setCreatePopup(true);
                setEditId("");
              }}
              className="ButtonCSS"
            >
              {" "}
              Create{" "}
            </button>
)}
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px" }}>
            <ReactTable
              data={state.GeoState.State}
              columns={columns}
              totalItems={state.GeoState.Total_count}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={state.GeoState.Total_count}
              Oncreate={(e) => {
                setCreatePopup(true);
                setEditId("");
              }}
              Filter={true}
              NoFilter ={true}
                       searchVal={TablePositionPersist?.Overall_stateDatas?.search == "" || TablePositionPersist?.Overall_stateDatas?.search ==undefined? "":TablePositionPersist.Overall_stateDatas.search}
              search_key={true}

            />
          </div>
        ) : null}
      </div>

      {CreatePopup ? (
        <StateCreateForm
          setShow={setCreatePopup}
          show={CreatePopup}
          currentPage={dtpageindex}
          EditId={EditId}
          search={search}
        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandelDelete}
          Content={"Do you want to delete the State"}

        />
      ) : null}
    </>
  );
};

export default State;
